// extracted by mini-css-extract-plugin
export default {"fallback":"ErrorBoundary_fallback__rJ1fn"};